import React from 'react';
import { fetchUtils, Button, Create, SimpleForm, NumberInput, TextInput, DateInput, AutocompleteArrayInput, SelectArrayInput, SelectInput, ReferenceArrayInput} from 'react-admin';
import EditIcon from '@material-ui/icons/Edit';
import RunReportIcon from '@material-ui/icons/PlayCircleFilledRounded';
import SaveIcon from '@material-ui/icons/Save';
import FolderOpenIcon from '@material-ui/icons/FolderOpen';
import DataTable from 'react-data-table-component';
import CloudDownload from '@material-ui/icons/CloudDownload';
import authProvider from './authProvider';
import { NoBidChartComponent } from './components/chart.js';
import { UserReportsList, ReportName } from './components/user_reports_list.js';
import { UserReportsForm } from './components/user_reports_form.js';
import { Drawer } from '@material-ui/core';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
const countryChoices = require('./components/countries.json');
const fetch = fetchUtils.fetchJson;

const BASE_URL = window.nobid_endpoint+'/adcost';

// https://github.com/jbetancur/react-data-table-component/blob/master/stories/DataTable/Basic/ExportCSV.stories.js
function convertArrayOfObjectsToCSV(array) {
  let result;

  const columnDelimiter = ',';
  const lineDelimiter = '\n';
  const keys = Object.keys(array[0]);

  result = '';
  result += keys.join(columnDelimiter);
  result += lineDelimiter;

  array.forEach(item => {
    let ctr = 0;
    keys.forEach(key => {
      if (ctr > 0) result += columnDelimiter;

      result += item[key];
      // eslint-disable-next-line no-plusplus
      ctr++;
    });
    result += lineDelimiter;
  });

  return result;
}
function downloadCSV(array) {
  const link = document.createElement('a');
  let csv = convertArrayOfObjectsToCSV(array);
  if (csv == null) return;

  const filename = 'export.csv';

  if (!csv.match(/^data:text\/csv/i)) {
    csv = `data:text/csv;charset=utf-8,${csv}`;
  }

  link.setAttribute('href', encodeURI(csv));
  link.setAttribute('download', filename);
  link.click();
}
const choicesInterval = [
  { id: 'none', name: '- None -' },
  { id: 'day', name: 'Daily' },
  { id: 'week', name: 'Weekly' },
  { id: 'month', name: 'Monthly' }
];
const dateRangeChoices = [
  {id: 1, name: 'Yesterday'},
  {id: 2, name: 'Last 2 Days'},
  {id: 3, name: 'Last 3 Days'},
  {id: 7, name: 'Last 7 Days'},
  {id: 8, name: 'Last 8 Days'},
  {id: 10, name: 'Last 10 Days'},
  {id: 30, name: 'Last 30 Days'},
  {id: 'custom', name: 'Custom'}
];
let choicesShow = [];
const choicesShowAdmin = [
    { id: 'publisher', name: 'Publisher' },
    { id: 'site', name: 'Site' },
    { id: 'tldomain', name: 'Domain / App' },
    { id: 'country', name: 'Country' },
    { id: 'total_aws_cost', name: 'AWS Cost' },
    { id: 'ad_calls', name: 'Ad Calls' },
    { id: 'ad_responses', name: 'Ad Responses' },
    { id: 'bid_requests', name: 'Bid Requests' },
    { id: 'bid_responses', name: 'Bid Responses' },
    { id: 'response_rate', name: '%Response Rate'},
    { id: 'bid_response_rate', name: '%Bid Response Rate'},
    { id: 'uids', name: 'Matched Users' },
    { id: 'match_rate', name: '%Match Rate'}
]
const choicesShowPublisher = [
  { id: 'publisher', name: 'Publisher' },
  { id: 'site', name: 'Site' },
  { id: 'country', name: 'Country' },
  { id: 'ad_responses', name: 'Ad Responses' },
  { id: 'response_rate', name: '%Response Rate'},
]
let chartMetricsChoices = [];
const chartMetricsChoicesAdmin = [
	{id:'revenue', name:'$Revenue'},
	{id:'impressions', name:'Impressions'},
  {id:'ad_requests', name:'Ad Requests'},
  {id:'ad_responses', name:'Ad Responses'},
	{id:'ad_calls', name: 'Ad Calls'},
	{id:'bid_requests', name: 'Bid Requests'},
	{id:'bid_responses', name: 'Bid Responses'},
  {id:'profit', name: '$Profit'},
  {id:'unified_profit', name: '$Unified Profit'},
	{id:'fill_rate_percent', name: '%Fille Rate'},
  {id:'response_rate', name: '%Response Rate'},
  {id:'bid_response_rate', name: '%Bid Response Rate'},
	{id:'match_rate', name: '%Match Rate'},
  {id:'total_aws_cost', name: '$AWS Cost'}
];
const chartMetricsChoicesPublisher = [
	{id:'publisher_revenue', name:'$Revenue'},
	{id:'impressions', name:'Impressions'},
  {id:'ad_requests', name:'Ad Requests'},
  {id:'ad_responses', name:'Ad Responses'},
  {id:'response_rate', name:'%Response Rate'},
	{id:'fill_rate_percent', name: '%Fille Rate'}
];
let metricChoices = [];
const metricChoicesAdmin = [
  { id: 'profit', name: 'Profit' },
  { id: 'unified_profit', name: 'Unified Profit' },
  { id: 'total_aws_cost', name: 'AWS Cost' },
  { id: 'publisher_revenue', name: 'Publisher Revenue' },
  { id: 'revenue', name: 'Gross Revenue' },
  { id: 'nobid_revenue', name: 'NoBid Revenue' },
  { id: 'ad_requests', name: 'Ad Requests' },
  { id: 'ad_responses', name: 'Ad Responses' },
  { id: 'impressions', name: 'Impressions' },
  { id: 'avg_cpm', name: 'Average CPM'},
  { id: 'ad_calls', name: 'Ad Calls' },
  { id: 'bid_requests', name: 'Bid Requests' },
  { id: 'bid_responses', name: 'Bid Responses' },
  { id: 'fill_rate_percent', name: '%Fill Rate' },
  { id: 'response_rate', name: '%Response Rate'},
  { id: 'bid_response_rate', name: '%Bid Response Rate'},
  { id: 'match_rate', name: '%Match Rate' }
];
const metricChoicesPublisher = [
  { id: 'publisher_revenue', name: 'Revenue' },
  { id: 'ad_requests', name: 'Ad Requests' },
  { id: 'ad_responses', name: 'Ad Responses' },
  { id: 'response_rate', name: '%Response Rate'},
  { id: 'impressions', name: 'Impressions' },
  { id: 'avg_cpm', name: 'Average CPM'},
  { id: 'fill_rate_percent', name: '%Fill Rate' },
];
const chartFormatChoices = [
	{id:'line', name:'Lines'},
	{id:'spline', name:'Smoothed'},
	{id:'column', name:'Bars'},
	{id:'area', name:'Area'},
];
const conditionalRowStyles = [
{   
    when: row => row.profit < 0,
    style: {color: 'red', backgroundColor: 'white'}
},
{   
    when: row => row.profit > 0,
    style: {color: 'green', backgroundColor: 'white'}
},
];
const BASE_COLUMNS = [
  {
    name: 'Date',
    selector: 'date',
    sortable: true,
    alwaysOnAdmin: false,
    alwaysOnPublisher: false,
    cell: row => row.date
  },
  {
    name: 'Publisher',
    selector: 'publisher_name',
    sortable: true,
    cell: row => <span>{ row.publisher_name }</span>
  },
  {
    name: 'Site',
    selector: 'site_name',
    sortable: true,
    cell: row => <span>{ row.site_name }</span>
  },
  {
    name: 'Site ID',
    selector: 'site_id',
    sortable: true,
    cell: row => <span>{ row.site_id }</span>
  },
  {
    name: 'Domain',
    selector: 'tldomain',
    sortable: true,
    cell: row => <span>{ row.tldomain }</span>
  },
  {
    name: 'Country',
    selector: 'country',
    sortable: true,
    cell: row => <span>{ row.country }</span>
  },
  {
    name: 'Profit',
    selector: 'profit',
    sortable: true,
    alwaysOnAdmin: true,
    alwaysOnPublisher: false,
    cell: row => <span>{ new Intl.NumberFormat().format(Number.parseFloat(row.profit).toFixed(2)) }</span>
  },
  {
    name: 'Unified Profit',
    selector: 'unified_profit',
    sortable: true,
    alwaysOnAdmin: true,
    alwaysOnPublisher: false,
    cell: row => <span>{ new Intl.NumberFormat().format(Number.parseFloat(row.unified_profit).toFixed(2)) }</span>
  },
  {
    name: '%Fill Rate',
    selector: 'fill_rate_percent',
    sortable: true,
    alwaysOnAdmin: true,
    alwaysOnPublisher: true,
    cell: row => <span>{ new Intl.NumberFormat().format(Number.parseFloat(row.fill_rate_percent).toFixed(2)) }</span>
  },
  {
    name: 'Impressions',
    selector: 'impressions',
    alwaysOnAdmin: true,
    alwaysOnPublisher: true,
    sortable: true,
    cell: row => <span>{ new Intl.NumberFormat().format(Number.parseFloat(row.impressions).toFixed(2)) }</span>
  },
  {
    name: 'Ad Requests',
    selector: 'ad_requests',
    alwaysOnAdmin: true,
    alwaysOnPublisher: true,
    sortable: true,
    cell: row => <span>{ new Intl.NumberFormat().format(Number.parseFloat(row.ad_requests).toFixed(2)) }</span>
  },
  {
    name: 'Ad Responses',
    selector: 'ad_responses',
    sortable: true,
    cell: row => <span>{ new Intl.NumberFormat().format(Number.parseFloat(row.ad_responses).toFixed(2)) }</span>
  },
  {
    name: 'Bid Requests',
    selector: 'bid_requests',
    sortable: true,
    cell: row => <span>{ new Intl.NumberFormat().format(Number.parseFloat(row.bid_requests).toFixed(2)) }</span>
  },
  {
    name: 'Bid Responses',
    selector: 'bid_responses',
    sortable: true,
    cell: row => <span>{ new Intl.NumberFormat().format(Number.parseFloat(row.bid_responses).toFixed(2)) }</span>
  },
  {
    name: 'Matched Users',
    selector: 'uids',
    sortable: true,
    cell: row => <span>{ new Intl.NumberFormat().format(Number.parseFloat(row.uids).toFixed(2)) }</span>
  },
  {
    name: '%Response Rate',
    selector: 'response_rate',
    sortable: true,
    cell: row => <span>{ new Intl.NumberFormat().format(Number.parseFloat(row.response_rate).toFixed(2)) }</span>
  },
  {
    name: '%Bid Response Rate',
    selector: 'bid_response_rate',
    sortable: true,
    cell: row => <span>{ new Intl.NumberFormat().format(Number.parseFloat(row.bid_response_rate).toFixed(2)) }</span>
  },
  {
    name: '%Match Rate',
    selector: 'match_rate',
    sortable: true,
    cell: row => <span>{ new Intl.NumberFormat().format(Number.parseFloat(row.match_rate).toFixed(2)) }</span>
  },
  {
    name: '$Revenue',
    selector: 'revenue',
    sortable: true,
    alwaysOnAdmin: true,
    alwaysOnPublisher: false,
    cell: row => <span>{ new Intl.NumberFormat().format(Number.parseFloat(row.revenue).toFixed(2)) }</span>
  },
  {
    name: 'Ad Calls',
    selector: 'ad_calls',
    sortable: true,
    cell: row => <span>{ new Intl.NumberFormat().format(Number.parseFloat(row.ad_calls).toFixed(2)) }</span>
  },
  {
    name: '$Pub Revenue',
    selector: 'publisher_revenue',
    sortable: true,
    alwaysOnAdmin: true,
    alwaysOnPublisher: true,
    cell: row => <span>{ new Intl.NumberFormat().format(Number.parseFloat(row.publisher_revenue).toFixed(2)) }</span>
  },
  {
    name: '$Pub Avg CPM',
    selector: 'avg_cpm',
    sortable: true,
    alwaysOnAdmin: true,
    alwaysOnPublisher: true,
    cell: row => <span>{ new Intl.NumberFormat().format(Number.parseFloat(row.avg_cpm).toFixed(2)) }</span>
  },
  {
    name: '$NoBid Rev',
    selector: 'nobid_revenue',
    sortable: true,
    alwaysOnAdmin: true,
    alwaysOnPublisher: false,
    cell: row => <span>{ new Intl.NumberFormat().format(Number.parseFloat(row.nobid_revenue).toFixed(2)) }</span>
  },
  {
    name: '$AWS Cost',
    selector: 'total_aws_cost',
    sortable: true,
    cell: row => <span>{ new Intl.NumberFormat().format(Number.parseFloat(row.total_aws_cost).toFixed(2)) }</span>
  },
  {
    name: 'Actions',
    cell: (row) => <Button href={'/#/sites/'+row.site_id} label="EDIT" variant="contained" color="primary" size='small' startIcon={<EditIcon />}/>,
    ignoreRowClick: true,
    allowOverflow: true,
    alwaysOnAdmin: true,
    alwaysOnPublisher: false,
    button: true,
  }
];
let columnsDateInterval = [];
columnsDateInterval['date'] = 'show';
let columnsShow = [];
let columns = [];
BASE_COLUMNS.forEach(e => {
  if (e.selector!=='site_id' 
		&& e.selector!=='site_name'
		&& e.selector!=='publisher_id'
		&& e.selector!=='publisher_name'
		&& e.selector!=='tldomain'
    && e.selector!=='country'
		&& e.selector!=='total_aws_cost'
		&& e.selector!=='bid_requests'
		&& e.selector!=='bid_responses'
    && e.selector!=='response_rate'
    && e.selector!=='bid_response_rate'
		&& e.selector!=='ad_calls'
		&& e.selector!=='match_rate'
    && e.selector!=='uids'
    ) {
      columns.push(e);
    }
});
var role = '';
class MetricFilterComponent extends React.Component {
  constructor(permissions, props) {
    super();
    permissions.authProvider.getPermissions().then( ({role}) => {
      role = role;
      choicesShow = (['admin', 'report_admin'].includes(role))?choicesShowAdmin:choicesShowPublisher;
      chartMetricsChoices = (['admin', 'report_admin'].includes(role))?chartMetricsChoicesAdmin:chartMetricsChoicesPublisher;
      metricChoices = (['admin', 'report_admin'].includes(role))?metricChoicesAdmin:metricChoicesPublisher;
      if (['publisher'].includes(role)) {
        columns = [];
        BASE_COLUMNS.forEach(e => {
          if (['date', 'impressions', 'publisher_revenue', 'ad_requests', 'ad_responses', 'fill_rate_percent', 'avg_cpm']
          .includes(e.selector)) columns.push(e);
        });
      }
    });
    this.state = {
      data: [] /* metric:"impressions", operator:"gt", value */
    };
    // window.setInterval(()=>{console.log('===>METRIC FILTER STATE:', this.state);}, 10000);
  }
  addMetric = () => {
    this.setState({
      data: this.state.data.concat([{ metric:'', operator:'' }])
    });
  };
  removeMetric = idx => () => {
    this.setState({
      data: this.state.data.filter((s, sidx) => idx !== sidx)
    });
  };
  random = () => { return Math.floor(Math.random()*9999999); }
  updateMetric = idx => event => {
    const newData = this.state.data.map((item, sidx) => {
      if (idx !== sidx) return item;
      let name = event.target.name;
      name = name.substring(0, name.indexOf('-'));
      item[name] = (name!=='value')?event.target.value:Number(event.target.value);
      return item;
    });
    this.setState({ data: newData });
  };
  render() {
    return (
      <div style={{width: '100%'}}>
        <div style={{float: 'left', width: '100%'}}>
          <div style={{float: 'left'}}><h4>Filter Metrics</h4></div>
          <div style={{float: 'left', paddingLeft: '30px', paddingTop: '18px'}}><Button onClick={this.addMetric} color='primary' label='Add Filter' startIcon={<AddCircleOutlineIcon />} /></div>
        </div>
        <SimpleForm toolbar={null}>
        {this.state.data.map((item, idx) => (
          <div key={idx} style={{float: 'left', width: '100%'}}>
            <div style={{float: 'left'}}>
              <SelectInput key={idx} source={'metric-'+this.random()} defaultValue={item.metric} label="Select Metric" 
                choices={metricChoices} onChange={this.updateMetric(idx)} />
            </div>
            <div style={{float: 'left', paddingLeft:'5px'}}>
              <SelectInput source={'operator-'+this.random()} defaultValue={item.operator} label="Is" 
                choices={[{ id: 'eq', name: 'Equals' },{ id: 'gt', name: 'Greater than' },{ id: 'lt', name: 'Less than' }]} 
                onChange={this.updateMetric(idx)}
              />
            </div>
            <div style={{float: 'left', paddingLeft:'5px'}}>
              <NumberInput source={'value-'+this.random()} defaultValue={item.value} label="Value" onChange={this.updateMetric(idx)} />
            </div>
            <div style={{float: 'left', paddingLeft:'5px', paddingTop: '18px'}}>
              <Button color='secondary' label='remove' onClick={this.removeMetric(idx)} startIcon={<HighlightOffIcon />} />
            </div>
          </div>
        ))}
        </SimpleForm>
      </div>
    );
  }
}

class AdCostComponent extends React.Component {
  state = {
    data: [],
    start_date: '',
    end_date: '',
    metric_filter: [],
    loading: true,
    saving: false,
    total: 0,
    perPage: 25,
    params : {_end:100000, _order:'ASC', _start:0},
    interval: 'day', 
    date_range:8, 
    show:[],
    tldomain: '',
    country: [],
    code: 0,
    publisher_id: [],
    site_id: [],
    report_name: '',
    schedule: null, 
    schedule_operator: null, 
    schedule_value: null,
    schedule_emails: ''
  };
  setState(obj) {
    if (obj.metric_filter) {
      this.refs.metricFilter.setState({data: []});
      this.refs.metricFilter.setState({data: obj.metric_filter});
      return;
    } else if (obj.show) this.resetColumns({target:{value: obj.show} }, this.props.permissions.role);
    else if (obj.interval) this.resetColumns({target:{value: obj.interval} }, this.props.permissions.role);
    super.setState(obj);
  }
  constructor(props) {
    super(props);
    this.state.loading = true;
    // window.setInterval(()=>{console.log('===>STATE:', this.state);}, 10000);
  }
  updateChart = function(obj, chartMetricsChoices, chartFormatChoices, options) {
	  if (!obj) return;
	  obj.refs.nobidChart.refreshChart(obj.state.data, chartMetricsChoices, chartFormatChoices, options);
  }
  joinForUrl(params) {
    let ret = '';
    let prepend = '';
    for (let key in params) {
      if (['data', 'saved_data', 'params', 'saving', 'loading', 'listing', 'old_params', 'perPage'].includes(key)) continue;
      let val = params[key];
      if (val) {
        if (!Array.isArray(val)) ret += prepend+key+'='+val;
        else {
          ret += prepend+key+'='+val.join('&'+key+'=');
        }
        prepend = '&';
      }
    }
    return ret;
  }
  getQueryString() {
    let ret = this.joinForUrl(this.state.params);
    let buf = '';
    let metrics = this.refs.metricFilter.state.data;
    if (metrics) for (let i in metrics) {
      let r = metrics[i];
      if (r && r.metric && r.operator && r.value) {
        buf += '&metrics='+r.metric+'|'+r.operator+'|'+r.value;
      }
    }
    if (buf!='') ret += buf;

    buf = this.joinForUrl(this.state);
    if (buf!='') ret += '&'+buf;
    return ret;
  }
  fetchData() {
    function updateState(obj, headers, json) {
      obj.setState({data: json, saved_data:json, loading: false});
      obj.updateChart(obj, chartMetricsChoices, chartFormatChoices);
    }
    this.setState({ loading: true });
    let url = `${BASE_URL}?${this.getQueryString()}`
    let options = {headers: new Headers()};
    options.headers.set('accept', 'application/json');
    const token = localStorage.getItem('token');
    options.headers.set('Authorization', `Bearer ${token}`);
    fetch(url, options).then(({ headers, json }) => (
      updateState(this, headers, json)
    ));
  }
  handleRefreshReport = () => {
	  this.fetchData();
  }
  resetColumns = (value, role) => {
    function isDateInterval(value) {
      return ['none', 'day', 'week', 'month', 'year'].includes(value);
    }
    let name = value.target.name;
    value = value.target.value;
    let v = [];
    if (!isDateInterval(value) && Array.isArray(value)) {
      columnsShow = [];
      value.forEach(val => { 
        if (val === 'publisher') {
          columnsShow['publisher_name'] = 'show';
        } else if (val === 'site') {
          columnsShow['site_name'] = 'show';
          columnsShow['site_id'] = 'show';
        } else {
          columnsShow[val] = 'show';
        }
      })
    }

    if (isDateInterval(value)) {
      columnsDateInterval = [];
      if (value!='none') columnsDateInterval['date'] = 'show';
    }

    BASE_COLUMNS.forEach(e => {
      if (columnsDateInterval[e.selector]=='show') v.push(e);
    })
    BASE_COLUMNS.forEach(e => {
      if (columnsShow[e.selector]=='show') v.push(e);
    })
    BASE_COLUMNS.forEach(e => {
      if (role==='admin' && e.alwaysOnAdmin) v.push(e);
      else if (role==='publisher' && e.alwaysOnPublisher) v.push(e);
    })
    columns = v;

    this.state[name] = value;
  }
  handleChartMetricChanged = (value) => {
	  this.updateChart(this, chartMetricsChoices, chartFormatChoices, {metric: value.target.value});
  }
  handleChartFormatChanged = (value) => {
	  this.updateChart(this, chartMetricsChoices, chartFormatChoices, {format: value.target.value});
  }
  componentDidMount() {
    this.fetchData();
  }
  rowClicked(record){
    window.location = `/#/sites/${record.site_id}`
  }
  exportData() {
    let records = this.state['data']
    downloadCSV(records)
  }
  filterData() {
    let val = document.getElementById('search_box').value
    let records = []
    if (this.state['saved_data']) records = this.state['saved_data']
    else {
      records = this.state['data']
      this.state['saved_data'] = records
    }
    let filtered = records.filter( item => {
    	let ret = true;
        if (item.publisher_name) {
      	  ret = item.publisher_name.toLowerCase().includes(val.toLowerCase());
        }
        if (item.site_name) {
      	  ret = item.site_name.toLowerCase().includes(val.toLowerCase());
        }
        if (item.placement_name) {
          ret = item.placement_name.toLowerCase().includes(val.toLowerCase());
        }
        if (item.bidder_name) {
    	  ret = item.bidder_name.toLowerCase().includes(val.toLowerCase());
        }
        if (item.tldomain) {
      	  ret = item.tldomain.toLowerCase().includes(val.toLowerCase());
        }
        if (item.country) {
      	  ret = item.country.toLowerCase().includes(val.toLowerCase());
        }
        return ret;
    });
    this.setState({data: filtered})
  }
  render(props) {
    const { loading, data } = this.state;
    return (

      <div id="wrapper1">
        <Drawer anchor='right' ref='list_reports' open={this.state.listing}>
        <div style={{width: '400px'}}>
        <UserReportsList parent={this} type='adrequest'/>
        </div>
        </Drawer>

        <Create basePath="/adcost" resource="" title="Request Reports" {...props}>
        <SimpleForm toolbar={null}>
        <ReportName parent={this} />

        <Drawer anchor='right' open={this.state.saving}>
        <div style={{width: '400px'}}>
        <UserReportsForm parent={this} type='adrequest'/>
        </div>
        </Drawer>

        <div style={{ width:'100%', overflow:'hidden' }} id="wrapper2">
        
          <div style={{ float:'left', paddingRight:'5px' }}>
          <SelectInput label="Interval" source='interval' choices={choicesInterval} 
            format={() => {return this.state.interval}} 
            onChange={value => this.setState({interval:value.target.value})} 
            disabled={loading}/>
 	        </div>

          <div style={{ float:'left', paddingRight:'5px' }}>
          <SelectInput label="Date Range" source="date_range" 
            format={() => {return this.state.date_range}} 
            choices={dateRangeChoices} 
            onChange={value => this.setState({date_range:value.target.value})} 
            disabled={loading}/>

          <div style={{ float:'right', paddingLeft:'5px', display:('custom'!=this.state.date_range)?'none':'block' }}>
          <div style={{ float:'left', paddingRight:'5px', display:('custom'!=this.state.date_range)?'none':'block' }}>
          <DateInput label="Start Date" source="start_date" allowEmpty
          format={() => {return this.state.start_date}}  
          onChange={value => this.setState({start_date:value.target.value})} 
          disabled={this.loading}
          style={{display:('custom'!=this.state.date_range)?'none':'block'}} />
          </div>
      
          <div style={{ float:'left', display:('custom'!=this.state.date_range)?'none':'block' }}>
          <DateInput label="End Date" source="end_date" allowEmpty 
          format={() => {return this.state.end_date}}  
          onChange={value => this.setState({end_date:value.target.value})} 
          disabled={this.loading}
          style={{display:('custom'!=this.state.date_range)?'none':'block'}} />
          </div>
          </div>

 	        </div>
      
          <div style={{ float:'left', paddingRight:'5px' }}>
          <SelectArrayInput label="Show"  source="show" 
            format={() => {return this.state.show;}}
            choices={choicesShow} 
            onChange={value => this.setState({show:value.target.value})} 
            style={{ width: '300px' }}
            disabled={loading} />
          </div>
          
          <div style={{ float:'right', paddingTop:'25px', paddingLeft:'10px' }}>
            <Button label='Run Report' onClick={this.handleRefreshReport} props={this} variant='contained'
            	color='primary' startIcon={<RunReportIcon />} disabled={loading}/>
            <span style={{paddingLeft: '5px'}}/>
            
            <Button label="Save" props={this} variant="contained" 
                onClick={event => this.setState({saving: true})}
                color="primary" startIcon={<SaveIcon />} disabled={loading} />

            <span style={{paddingLeft: '5px'}}/>
            <Button label="Open" onClick={event => this.setState({listing: true})} props={this} variant="contained" 
            	color="primary" startIcon={<FolderOpenIcon />} disabled={loading}/>
          </div>
          
        </div>
      
        <div style={{ height: '15px' }} />
      
        <div style={{ width:'100%', overflow:'hidden' }} id="wrapper3">
          <div style={{ float:'left', paddingRight:'5px' }}>
            <ReferenceArrayInput 
            source="publisher_id" 
            format={() => {return this.state.publisher_id;}}
            label="Publisher" 
            reference="publishers"
            basePath='publishers'
    	      perPage={15} 
      	    sort={{ field: 'name', order: 'ASC' }}
      	    filterToQuery={searchText => ({ search_name: searchText })}
            allowEmpty
            onChange={value => this.state.publisher_id=value}
            disabled={loading}
            >
            <AutocompleteArrayInput label="Publishers" 
            optionText="name" 
            optionValue="code" 
            style={{ width: '100%' }}
            />
            </ReferenceArrayInput>
          </div>
      
          <div style={{ float:'left', paddingRight:'5px' }}>
            <ReferenceArrayInput 
            source="site_id" 
            format={() => {return this.state.site_id;}}
            label="Site" 
            reference="sites"
            basePath="sites"
    	      perPage={15} 
      	    sort={{ field: 'name', order: 'ASC' }}
      	    filterToQuery={searchText => ({ search_name: searchText })}
      	    allowEmpty
            onChange={value => this.state.site_id=value}
            disabled={loading}>
            <AutocompleteArrayInput label="Sites" optionText="adunit_path" optionValue="code" style={{ width: '100%' }}/>
            </ReferenceArrayInput>
          </div>

          <div style={{ float:'left', paddingRight:'5px' }}>
          <SelectArrayInput label="Countries"
          source="country"
          choices={countryChoices}
          onChange={value => this.state.country=value.target.value}
          style={{ width: '300px' }}
          disabled={loading} />
          </div>
      
          {(role!=='publisher') && 
          <div style={{ float:'left', paddingRight:'5px' }}>
            <TextInput source="tldomain" label="Domain / App" 
              format={() => {return this.state.tldomain;}}
              onChange={value => this.setState({tldomain:value.target.value})}
              style={{ width: '400px' }} 
              disabled={loading}/>
          </div>
          }

          <div style={{ float:'right' }}>
          <SelectInput label="Chart Format" 
          	source='format' 
            choices={chartFormatChoices}
            defaultValue={'line'}
            onChange={this.handleChartFormatChanged} 
            disabled={loading}
            style={{ paddingRight: '5px' }}
          />
          <SelectInput label="Show in Chart"
        	  source='metric' 
            choices={chartMetricsChoices}
            defaultValue={'revenue'}
            onChange={this.handleChartMetricChanged} 
            disabled={loading}
          />
          </div>

          <div >
          <MetricFilterComponent ref='metricFilter' {...props} authProvider={authProvider} />
          </div>

        </div>

        </SimpleForm>
        </Create>

        <div style={{ height: '5px' }} />
        
        <NoBidChartComponent ref="nobidChart" authProvider={authProvider}/>
      
        <div style={{ height: '5px' }} />
	      <DataTable
	        title="Request Report"
	        theme="dark"
	        columns={columns}
	        data={data}
	        progressPending={loading}
	        pagination
	        fixedHeader
	        paginationPerPage={30}
	        dense
	        XXXconditionalRowStyles={conditionalRowStyles}
	        highlightOnHover
	        subHeader={!loading}
	        subHeaderComponent={
	          (
	            <div style={{ display: 'flex', alignItems: 'center' }}>
	              <input type="text" id='search_box' label="Search" 
	              variant="outlined" 
	              style={{ margin: '5px' }} 
	              onChange={(target) => this.filterData()}/>
	              <CloudDownload 
	              label="Export"
	              style={{ margin: '5px' }} 
	              color="action" 
	              onClick={() => this.exportData()}
	              />
	            </div>
	          )
	        }
	    />

      </div>
    )
  }
};
export const AdServingCostList = (props) => (
  <AdCostComponent {...props}/>
);